import Head from 'next/head'
import { sanityClient } from '@bww/beke-lib/sanity-client'
import BrandHeader from '@bww/beke-ui/Brands/BrandHeader'
import YourDreamCTA from '@bww/beke-ui/YourDreamCTA'
import { toPlainText, PortableText } from '@portabletext/react'

export default function BrandPage({ brand }) {
  const { name, description, logo, url } = brand
  const fallbackDesc = `${name} products available from Bathroom Elegance`
  return (
    <>
      <Head>
        <title>{`${name} by Bathroom Elegance`}</title>
        <meta
          name="description"
          content={description ? toPlainText(description) : fallbackDesc}
        />
      </Head>
      <BrandHeader name={name} logo={logo} />
      <div className="pageContainer" style={{ paddingTop: 40 }}>
        {description && (
          <>
            <h1 className="h1">About {name} </h1>
            <div>
              <PortableText value={description} />
            </div>
          </>
        )}
        {url && (
          <a
            className="button button--small"
            href={url}
            rel="external noopener noreferrer nofollow"
            style={{ marginTop: 30 }}
          >
            Supplier Website
          </a>
        )}
      </div>
      <YourDreamCTA />
    </>
  )
}

export const getStaticProps = async (context) => {
  const brand = await sanityClient.fetch(
    `*[_type == "brand" && slug.current == $slug][0]{
        name,
        "slug": slug.current,
        description,
        url,
        "logo": logo{ "src": asset->url, "bleedColor": bleedColor.hex },
      }`,
    { slug: context.params.slug },
  )

  if (!brand) return { redirect: { destination: '/brands', permanent: false } }

  return {
    props: { brand },
  }
}

export async function getStaticPaths() {
  const brands = await sanityClient.fetch(
    `*[_type == "brand" && "be" in companies]{ "slug": slug.current }`,
  )

  return {
    paths: brands.map(({ slug }) => ({
      params: { slug },
    })),
    fallback: false,
  }
}
